export const DECIMAL_SEPARATOR = Object.freeze({
  POINT: 'point',
  COMMA: 'comma',
});

export const CURRENCY_DEFAULT = 'EUR';

export const CURRENCY_TO_SYMBOL = Object.freeze({
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: 'Bs.',
  BRL: 'R$',
  BSD: '$',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BZD: '$',
  CAD: '$',
  CDF: 'FC',
  CHF: 'CHF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  CUP: '$',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'Kr.',
  DOP: '$',
  DZD: 'د.ج',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GHS: '₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JMD: '$',
  JOD: 'د.ا',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'сом',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'د.ك',
  KYD: '$',
  KZT: '₸',
  LAK: '₭',
  LBP: 'ل.ل',
  LKR: 'Rs',
  LRD: '$',
  LSL: 'L',
  LYD: 'ل.د',
  MAD: 'د.م.',
  MDL: 'L',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: '$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: 'ر.ع.',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: '₲',
  QAR: 'ر.ق',
  RON: 'lei',
  RSD: 'din.',
  RUB: '₽',
  RWF: 'RF',
  SAR: 'ر.س',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'Sh',
  SRD: '$',
  SSP: '£',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRY: '₺',
  TTD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYU: '$',
  UZS: 'сўм',
  VES: 'Bs.S',
  VND: '₫',
  VUV: 'VT',
  WST: 'T',
  XAF: 'FCFA',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  YER: '﷼',
  ZAR: 'R',
  ZMW: 'ZK',
  ZWL: '$',
});

export const CURRENCIES_POPULAR = Object.freeze(['EUR', 'USD', 'GBP', 'CHF', 'CAD', 'AUD', 'SEK', 'NOK', 'DKK', 'PLN']);

export const CURRENCY_TO_NAME = Object.freeze({
  AFN: 'Afghani',
  DZD: 'Algerian Dinar',
  ARS: 'Argentine Peso',
  AMD: 'Armenian Dram',
  AWG: 'Aruban Florin',
  AUD: 'Australian Dollar',
  AZN: 'Azerbaijan Manat',
  BSD: 'Bahamian Dollar',
  BHD: 'Bahraini Dinar',
  THB: 'Baht',
  PAB: 'Balboa',
  BBD: 'Barbados Dollar',
  BYN: 'Belarusian Ruble',
  BZD: 'Belize Dollar',
  BMD: 'Bermudian Dollar',
  BOB: 'Boliviano',
  VES: 'Bolívar Soberano',
  BRL: 'Brazilian Real',
  BND: 'Brunei Dollar',
  BGN: 'Bulgarian Lev',
  BIF: 'Burundi Franc',
  CVE: 'Cabo Verde Escudo',
  CAD: 'Canadian Dollar',
  KYD: 'Cayman Islands Dollar',
  XOF: 'CFA Franc BCEAO',
  XAF: 'CFA Franc BEAC',
  XPF: 'CFP Franc',
  CLP: 'Chilean Peso',
  CNY: 'Chinese Yuan',
  COP: 'Colombian Peso',
  KMF: 'Comorian Franc',
  CDF: 'Congolese Franc',
  BAM: 'Convertible Mark',
  NIO: 'Cordoba Oro',
  CRC: 'Costa Rican Colon',
  CUP: 'Cuban Peso',
  CZK: 'Czech Koruna',
  GMD: 'Dalasi',
  DKK: 'Danish Krone',
  MKD: 'Denar',
  DJF: 'Djibouti Franc',
  STN: 'Dobra',
  DOP: 'Dominican Peso',
  VND: 'Dong',
  XCD: 'East Caribbean Dollar',
  EGP: 'Egyptian Pound',
  SVC: 'El Salvador Colon',
  ETB: 'Ethiopian Birr',
  EUR: 'Euro',
  FKP: 'Falkland Islands Pound',
  FJD: 'Fiji Dollar',
  HUF: 'Forint',
  GHS: 'Ghana Cedi',
  GIP: 'Gibraltar Pound',
  HTG: 'Gourde',
  PYG: 'Guarani',
  GNF: 'Guinean Franc',
  GYD: 'Guyana Dollar',
  HKD: 'Hong Kong Dollar',
  UAH: 'Hryvnia',
  ISK: 'Iceland Krona',
  INR: 'Indian Rupee',
  IRR: 'Iranian Rial',
  IQD: 'Iraqi Dinar',
  JMD: 'Jamaican Dollar',
  JOD: 'Jordanian Dinar',
  KES: 'Kenyan Shilling',
  PGK: 'Kina',
  HRK: 'Kuna',
  KWD: 'Kuwaiti Dinar',
  AOA: 'Kwanza',
  MMK: 'Kyat',
  LAK: 'Lao Kip',
  GEL: 'Lari',
  LBP: 'Lebanese Pound',
  ALL: 'Lek',
  HNL: 'Lempira',
  SLL: 'Leone',
  LRD: 'Liberian Dollar',
  LYD: 'Libyan Dinar',
  SZL: 'Lilangeni',
  LSL: 'Loti',
  MGA: 'Malagasy Ariary',
  MWK: 'Malawi Kwacha',
  MYR: 'Malaysian Ringgit',
  MUR: 'Mauritius Rupee',
  MXN: 'Mexican Peso',
  MDL: 'Moldovan Leu',
  MAD: 'Moroccan Dirham',
  MZN: 'Mozambique Metical',
  NGN: 'Naira',
  ERN: 'Nakfa',
  NAD: 'Namibia Dollar',
  NPR: 'Nepalese Rupee',
  ANG: 'Netherlands Antillean Guilder',
  ILS: 'New Israeli Sheqel',
  TWD: 'New Taiwan Dollar',
  NZD: 'New Zealand Dollar',
  BTN: 'Ngultrum',
  KPW: 'North Korean Won',
  NOK: 'Norwegian Krone',
  MRU: 'Ouguiya',
  PKR: 'Pakistan Rupee',
  MOP: 'Pataca',
  TOP: "Pa'anga",
  UYU: 'Peso Uruguayo',
  PHP: 'Philippine Peso',
  GBP: 'Pound Sterling',
  BWP: 'Pula',
  QAR: 'Qatari Rial',
  GTQ: 'Quetzal',
  ZAR: 'Rand',
  OMR: 'Rial Omani',
  KHR: 'Riel',
  RON: 'Romanian Leu',
  IDR: 'Rupiah',
  RUB: 'Russian Ruble',
  RWF: 'Rwanda Franc',
  SHP: 'Saint Helena Pound',
  SAR: 'Saudi Riyal',
  RSD: 'Serbian Dinar',
  SCR: 'Seychelles Rupee',
  SGD: 'Singapore Dollar',
  PEN: 'Sol',
  SBD: 'Solomon Islands Dollar',
  KGS: 'Som',
  SOS: 'Somali Shilling',
  TJS: 'Somoni',
  SSP: 'South Sudanese Pound',
  LKR: 'Sri Lanka Rupee',
  SDG: 'Sudanese Pound',
  SRD: 'Surinam Dollar',
  SEK: 'Swedish Krona',
  CHF: 'Swiss Franc',
  SYP: 'Syrian Pound',
  BDT: 'Taka',
  WST: 'Tala',
  TZS: 'Tanzanian Shilling',
  KZT: 'Tenge',
  TTD: 'Trinidad and Tobago Dollar',
  MNT: 'Tugrik',
  TND: 'Tunisian Dinar',
  TRY: 'Turkish Lira',
  TMT: 'Turkmenistan New Manat',
  AED: 'UAE Dirham',
  UGX: 'Uganda Shilling',
  USD: 'US Dollar',
  UZS: 'Uzbekistan Sum',
  VUV: 'Vatu',
  KRW: 'Won',
  YER: 'Yemeni Rial',
  JPY: 'Yen',
  ZMW: 'Zambian Kwacha',
  ZWL: 'Zimbabwe Dollar',
  PLN: 'Zloty',
  MVR: 'Rufiyaa',
});
